<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto" />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">GOODANG KDMP DISTRIBUTION WMS</h4>
                  <p>Please login to your account.</p>
                </div>
                <vs-input
                  icon="icon icon-user"
                  icon-pack="feather"
                  label-placeholder="Email"
                  v-model="email"
                  class="w-full no-icon-border"
                  v-on:keyup="keyEnter"
                />

                <vs-input
                  type="password"
                  icon="icon icon-lock"
                  icon-pack="feather"
                  label-placeholder="Password"
                  v-model="password"
                  class="w-full mt-6 no-icon-border"
                  v-on:keyup="keyEnter"
                />

                <div class="flex flex-wrap justify-between mt-5 mb-3">
<!--                   <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox> -->
                </div>

                <vs-alert :active="err != ''" color="danger" icon-pack="feather" icon="icon-info" class="mb-5">
                  {{err}}
                </vs-alert>
                <div class="flex flex-wrap">
                  <vs-button class="float-right" @click="saveForm()">Login</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      isLoading: false,
      email: "",
      password: "",
      checkbox_remember_me: false,
      err: ""
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    }
  },
  methods: {
    ...mapActions(["setUserState"]),
    saveForm() {
      this.err = "";
      this.isLoading = true;
      if (this.email == "") {
        setTimeout(() => {
          this.isLoading = false;
          this.err = "Email required";
        }, 500);
        return;
      }
      if (this.password == "") {
        setTimeout(() => {
          this.isLoading = false;
          this.err = "Password required";
        }, 500);
        return;
      }
      this.$http
        .post("/auth/login", { email: this.email, password: this.password })
        .then(resp => {
          // let rstr = JSON.stringify(resp.data);
          // localStorage.setItem('wms_daccess', rstr);
          // this.$http.defaults.headers.common['token'] = resp.data.token;
          this.$Cookies.remove('wms_session_token');
          this.$Cookies.set('wms_session_token', resp.data.token, { expires: 1 });
          this.setUserState(resp.data);
          this.$router.replace("/dashboard");
          this.$http.defaults.headers.common[
            "token"
          ] = this.$store.state.user.token;
        })
        .catch(resp => {
          if (resp.response.status == 500 || resp.response.status == 400) {
            this.isLoading = false;
            this.err = resp.response.data.error;
          }
        });
    },
    keyEnter: function(e) {
      if (e.keyCode === 13) {
        this.saveForm();
      }
    }
  },
  mounted() {
    if (this.isLoading) {
      this.$vs.loading();
    }
    let user = localStorage.getItem("wms_daccess");
    if (user != null) {
      this.$router.replace("/inbound-delivery");
    }
  }
};
</script>

<style>
#page-login .vs-input--input.normal {
  padding: 0.7rem !important;
  font-size: 1rem;
}
#page-login .vs-input--input.hasIcon {
  padding: 0.7rem 1rem 0.7rem 3rem !important;
}
</style>
